import styled from "styled-components";

export const WhatsappButtonWrapper = styled.div`
  position: fixed;
  background-color: #128C7E;
  border-radius: 50%;
  z-index: 10000;
  right: 10px;
  bottom: 6%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
